/** @format */

import React, { useCallback, useEffect, useState } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import CardHeader from '../../components/Heading/CardHeaderExt';
import CardBody from '../../components/Card/CardBody';
import Card from '../../components/Card/Card';
import SimpleSelectRest from '../../components/Adescom/SimpleSelectRest';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { pricelistSchemaConstants, pricelistsReducersType } from '../../modules/pricelists/reducers';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import Order from '../../interfaces/forms/Order';
import Filter from '../../interfaces/forms/Filter';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import { NotificationHelper } from '../../helpers/NotificationHelper';
import { prefixesConstants, prefixesReducersType } from '../../modules/prefixes/reducers';
import PrefixList from '../Prefixes/PrefixList';
import PrefixInterface from '../../interfaces/billing/PrefixInterface';
import AddButton from '../../components/Buttons/AddButton';
import TableHeaderContentCell from '../../components/Table/TableHeaderContentCell';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import RemoveButton from '../../components/Buttons/RemoveButton';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import I18n from '../../components/Translate/I18n';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';
import BillingPlatformResellerList from '../Tariffing/BillingComponents/BillingPlatformResellerList';
import BillingSelectedPlatformResellerList from '../Tariffing/BillingComponents/BillingSelectedPlatformResellerList';

const Retarification = (props: { classes: any }): React.ReactElement => {
    const { classes } = props;
    const dispatch = useDispatch();

    const tableStickyHeader = { root: classes.tableStickyHeader };
    const tableCellRoot = { root: classes.tableCellRoot };

    const URI = '/retarification_types';
    const URI2 = '/retarification_histories';

    const [filters, setFilters] = useState<Array<Filter>>([{ name: 'visible', value: true }]);
    const [orders, setOrders] = useState<Array<Order>>([]);

    const [selectedPrefixes, setSelectedPrefixes] = useState<Array<PrefixInterface>>([]);
    const [selectedMonth, setSelectedMonth] = useState<number | null>(null);
    const [isFinished, setIsFinished] = useState<boolean | null>(null);
    const [selectedResellers, setSelectedResellers] = useState<Array<{ mainname: string; id: number; nip: string }>>([]);
    const { collections } = useSelector((state: { pricelistSchemasReducers: pricelistsReducersType }) => {
        return state.pricelistSchemasReducers;
    });
    const prefixes = useSelector((state: { prefixesReducers: prefixesReducersType }) => {
        return state.prefixesReducers.collections;
    });

    const [entity, setEntity] = useState<any>({
        retarificationTypeId: null,
        dateFrom: null,
        dateTo: null,
    });

    const changeSelect = (e: any, stateName: string, require: boolean): void => {
        setEntity({ ...entity, [stateName]: e.target.value });
    };
    const changeDate = (e: any, stateName: string, require: boolean): void => {
        setSelectedMonth(e.target.value);
        setEntity({ ...entity, month: e.target.value });
    };

    const loadRetarificationTypes = useCallback(
        (uri?: string) => {
            if (!uri) {
                uri = FormGeneralHelper.getPath(URI);
            }
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.getListWithCallback(FormGeneralHelper.getByUri(uri), pricelistSchemaConstants.LIST, filters, orders, (data: any) => {}, {
                propagateDataToCallback: false,
                dispatchAfterCallback: true,
            });
        },
        [filters, orders, dispatch]
    );

    const checkIfRetarificationIsFinished = useCallback(
        (uri?: string) => {
            if (!uri) {
                uri = FormGeneralHelper.getPath(URI2);
            }
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.getListWithCallback(
                FormGeneralHelper.getByUri(uri),
                pricelistSchemaConstants.LIST,
                [],
                [],
                (data: any) => {
                    if (data && data['hydra:member'].length > 0) {
                        const result = data['hydra:member'][0];
                        if (result) {
                            const x = JSON.parse(result.params);
                            const amount = x.isFinished;
                            if (amount === 0) {
                                setIsFinished(true);
                            } else {
                                setIsFinished(false);
                            }
                        }
                    }
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                }
            );
        },
        [dispatch]
    );

    const executeRetarification = (): void => {
        const itemLoaders = new ItemLoaders(dispatch);

        if (!entity.retarificationTypeId) {
            NotificationHelper.notifyError('retarification:notify.type_not_selected', dispatch);
            return;
        }

        if (!entity.month) {
            NotificationHelper.notifyError('retarification:notify.date_not_selected', dispatch);
            return;
        }

        if (selectedPrefixes.length > 0) {
            entity.params = JSON.stringify({
                prefixes: selectedPrefixes.map((el: PrefixInterface) => {
                    return el.prefix;
                }),
            });
        }

        if (selectedResellers.length > 0) {
            entity.params = JSON.stringify({
                platformResellers: selectedResellers.map((el) => {
                    return el.id;
                }),
            });
        }

        itemLoaders.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath(URI2)),
            pricelistSchemaConstants.ADD,
            entity,
            (data: any) => {
                setIsFinished(null);
                checkIfRetarificationIsFinished();
            },
            { propagateDataToCallback: false, dispatchAfterCallback: true }
        );
    };

    const addPrefixes = (param: { el: PrefixInterface }): void => {
        if (
            !selectedPrefixes.some((pf: PrefixInterface) => {
                return pf.id === param.el.id;
            })
        ) {
            let newArr = [...selectedPrefixes, param.el];
            setSelectedPrefixes(newArr);
        }
    };
    const removePrefixes = (param: { el: PrefixInterface }): void => {
        let newArr = [...selectedPrefixes];
        selectedPrefixes.forEach((el: PrefixInterface, indx: number) => {
            if (el.id === param.el.id) {
                newArr.splice(indx, 1);
            }
        });
        setSelectedPrefixes(newArr);
    };

    const renderOutsideButtons = (el: PrefixInterface): React.ReactElement => {
        return (
            <AddButton
                callback={addPrefixes}
                callbackParam={{ el: el }}
                disabled={selectedPrefixes.some((sf: PrefixInterface) => {
                    return sf.id === el.id;
                })}
            />
        );
    };

    const selectPlatformReseller = (params: { mainname: string; id: number; nip: string }): void => {
        let exists = false;
        selectedResellers.map((el: { mainname: string; id: number; nip: string }) => {
            if (params.id === el.id) {
                exists = true;
            }
        });

        if (!exists) {
            const resellers = [...selectedResellers, params];
            setSelectedResellers(resellers);
        }
    };

    const removePlatformReseller = (params: { mainname: string; id: number; nip: string }): void => {
        let newSelected = [...selectedResellers];
        newSelected.map((el: { mainname: string; id: number; nip: string }, indx: number) => {
            if (params.id === el.id) {
                newSelected.splice(indx, 1);
            }
        });
        setSelectedResellers(newSelected);
    };

    const clearPlatformResellers = (): void => {
        setSelectedResellers([]);
    };

    useEffect(() => {
        loadRetarificationTypes();
    }, [loadRetarificationTypes]);

    useEffect(() => {
        checkIfRetarificationIsFinished();
    }, [checkIfRetarificationIsFinished]);

    useEffect(() => {
        if (entity.retarificationTypeId !== 2 && selectedPrefixes.length > 0) {
            setSelectedPrefixes([]);
        }

        if (entity.retarificationTypeId !== 7 && selectedResellers.length > 0) {
            setSelectedResellers([]);
        }
    }, [entity.retarificationTypeId, selectedPrefixes, selectedResellers]);

    return (
        <GridContainer spacing={2}>
            <GridItem xs={4}>
                <Card style={{ height: 400, overflowY: 'auto' }}>
                    <CardHeader trans="retarification:h.retarification" />
                    <CardBody>
                        <GridContainer>
                            <GridItem xs={12}>
                                <SimpleSelectRest
                                    callback={changeSelect}
                                    restElements={collections}
                                    stateName="retarificationTypeId"
                                    idState="retarificationTypeId"
                                    idSelected={entity.retarificationTypeId}
                                    propKey="id"
                                    required={false}
                                    propValue="mainname"
                                    emptyLabel="retarification:h.retarification_type"
                                    label="retarification:h.retarification_type"
                                />
                            </GridItem>
                            <GridItem xs={12}>
                                <SimpleSelectRest
                                    callback={changeDate}
                                    restElements={DateHelperTs.getMonths(true, true)}
                                    stateName="selectedMonth"
                                    idState="selectedMonth"
                                    idSelected={selectedMonth}
                                    propKey="id"
                                    required={false}
                                    propValue="name"
                                    emptyLabel="retarification:h.retarification_month"
                                    label="retarification:h.retarification_month"
                                />
                            </GridItem>
                            <GridItem xs={12} style={{ marginTop: 20 }}>
                                {isFinished === true && (
                                    <CustomTextButtom
                                        callback={executeRetarification}
                                        color={'primary'}
                                        size={'lg'}
                                        label={'retarification:h.execute_retarification'}
                                    />
                                )}
                                {isFinished !== null && !isFinished && <I18n trans={'retarification:h.in_progress'} />}
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </GridItem>
            {selectedResellers && selectedResellers.length > 0 && (
                <GridItem xs={8}>
                    <Card style={{ height: 400, overflowY: 'auto' }}>
                        <CardBody>
                            <BillingSelectedPlatformResellerList
                                selectedPlatformUsers={selectedResellers}
                                removePlatformResellerCallback={removePlatformReseller}
                                clearPlatformResellersCallback={clearPlatformResellers}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
            )}
            {selectedPrefixes.length > 0 && entity.retarificationTypeId === 2 && (
                <GridItem xs={8}>
                    <Card style={{ height: 400, overflowY: 'auto' }}>
                        <CardBody>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell classes={tableStickyHeader} align="left">
                                            <TableHeaderContentCell textAlign="left" title="clients:c.commands" />
                                        </TableCell>
                                        <TableCell classes={tableStickyHeader} align="left">
                                            <TableHeaderContentCell textAlign="left" title="prefixes:h.prefix_name" />
                                        </TableCell>
                                        <TableCell classes={tableStickyHeader} align="left">
                                            <TableHeaderContentCell textAlign="left" title="prefixes:h.prefix" />
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedPrefixes &&
                                        selectedPrefixes.map((el: PrefixInterface) => {
                                            return (
                                                <TableRow key={el.id}>
                                                    <TableCell classes={tableCellRoot} align="left">
                                                        {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_TARIFF_PUT) && (
                                                            <RemoveButton
                                                                tooltipTitle="tariffs:button.edit_tariff"
                                                                callback={removePrefixes}
                                                                callbackParam={{ el: el }}
                                                                disabled={
                                                                    !selectedPrefixes.some((sf: PrefixInterface) => {
                                                                        return sf.id === el.id;
                                                                    })
                                                                }
                                                            />
                                                        )}
                                                    </TableCell>
                                                    <TableCell classes={tableCellRoot} align="left">
                                                        {el.mainname}
                                                    </TableCell>
                                                    <TableCell classes={tableCellRoot} align="left">
                                                        {el.prefix}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </CardBody>
                    </Card>
                </GridItem>
            )}
            {entity.retarificationTypeId === 2 && (
                <GridItem xs={12}>
                    <Card>
                        <CardHeader trans="retarification:h.prefix_list" />
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12}>
                                    <PrefixList hideInsideButtons={true} renderOutsideButtons={renderOutsideButtons} />
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                    </Card>
                </GridItem>
            )}
            {entity.retarificationTypeId === 7 && (
                <GridItem xs={12}>
                    <Card>
                        <CardHeader trans="retarification:h.partner_list" />
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12}>
                                    <BillingPlatformResellerList selectPlatformReseller={selectPlatformReseller} />
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                    </Card>
                </GridItem>
            )}
        </GridContainer>
    );
};

export default withStyles(oplAppStyle)(Retarification);
